import create from 'zustand/vanilla';

type State = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  context: Record<string, any> | null;
};

export const store = create<State>(() => ({ context: null }));
